var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    viewBox: "0 0 38 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0.585938V11.9999H37.414L26 0.585938Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 14C24.448 14 24 13.552 24 13V2C24 0.89543 23.1046 0 22 0H1C0.448 0 0 0.448 0 1V45C0 45.552 0.448 46 1 46H37C37.552 46 38 45.552 38 45V16C38 14.8954 37.1046 14 36 14H25ZM9 14H17C17.552 14 18 14.448 18 15C18 15.552 17.552 16 17 16H9C8.448 16 8 15.552 8 15C8 14.448 8.448 14 9 14ZM29 36H9C8.448 36 8 35.552 8 35C8 34.448 8.448 34 9 34H29C29.552 34 30 34.448 30 35C30 35.552 29.552 36 29 36ZM29 26H9C8.448 26 8 25.552 8 25C8 24.448 8.448 24 9 24H29C29.552 24 30 24.448 30 25C30 25.552 29.552 26 29 26Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFile);
export default __webpack_public_path__ + "static/media/default-file.1fec1494a9c592b7d785a9fa25fc1765.svg";
export { ForwardRef as ReactComponent };